'use client';

import React, { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import Cookies from 'js-cookie';

const Utm = () => {
  const params = useSearchParams();

  useEffect(() => {
    const utmParams = {
      utm_source: params.get('utm_source'),
      utm_medium: params.get('utm_medium'),
      utm_campaign: params.get('utm_campaign'),
      utm_content: params.get('utm_content'),
      utm_term: params.get('utm_term'),
    };

    if (Object.values(utmParams).some((val) => !!val && val.length > 0)) {
      Cookies.set('utm_params', JSON.stringify(utmParams), { expires: 30 });
    }
  }, []);

  return <></>;
};

export default Utm;
